import React from 'react';
import { PageHeader } from '@ant-design/pro-layout';
import WarehouseWriteoffReport from 'components/warehouse_writeoff_report';

const MaterialsReport = () => (
  <React.Fragment>
    <PageHeader
      title="Отчёт по складу"
      style={{ paddingLeft: 0, paddingRight: 0, paddingTop: 0 }}
    />
    <WarehouseWriteoffReport showUserFilter />
  </React.Fragment>
);

export default MaterialsReport;
